import React from 'react';
import Zoom from 'react-reveal/Zoom';
const VisCard = () => {
  return (
    <section className="white-section" id="viscard">
      <div className="container-fluid">
        <div className="row">
          <Zoom left>
          <div className="col-lg-6">
          <img className="Vis-image" src={require('./Visiting card front.jpeg')} alt="Rebounce" />
          </div>
          </Zoom>
          <Zoom right>
          <div className="col-lg-6">
            <img className="Vis-image" src={require('./Visiting card back.jpeg')} alt="Rebounce" />
          </div>
          </Zoom>
        </div>
      </div>
    </section>
  );
};

export default VisCard;